import { post } from '../utils/backend';
import { getMockData, mock } from './mock/Mock';
import './mock/TechSupportMock';

export interface RedisConfigItemDTO {
  key: string;
  name: string;
  value: string;
}

export interface SmsCodeStatusDTO {
  phoneNumber: string;
  verificationCode: string | null;
  codeType: string;
  expired: boolean;
}

const getRedisConfigs = async (): Promise<RedisConfigItemDTO[]> => {
  if (mock) return getMockData('getRedisConfigs');

  const resultOrErrorCode = await post<Record<string, never>, RedisConfigItemDTO[]>(
    '/techSupport/getRedisConfigs',
    {}
  );
  if (typeof resultOrErrorCode === 'string') {
    return [];
  }
  return resultOrErrorCode || [];
};

const setPraiseWallMinPrice = async (value: number): Promise<boolean> => {
  if (mock) return getMockData('setPraiseWallMinPrice');

  const resultOrErrorCode = await post<{ value: number }, boolean>(
    '/techSupport/setPraiseWallMinPrice',
    { value }
  );
  if (typeof resultOrErrorCode === 'string') {
    return false;
  }
  return !!resultOrErrorCode;
};

const getSmsCodeStatus = async (phoneNumber: string): Promise<SmsCodeStatusDTO | null> => {
  if (mock) return getMockData('getSmsCodeStatus');

  const resultOrErrorCode = await post<{ phoneNumber: string }, SmsCodeStatusDTO>(
    '/techSupport/getSmsCodeStatus',
    { phoneNumber }
  );
  if (typeof resultOrErrorCode === 'string') {
    return null;
  }
  return resultOrErrorCode || null;
};

const sendSmsCode = async (phoneNumber: string): Promise<boolean> => {
  if (mock) return getMockData('sendSmsCode');

  const resultOrErrorCode = await post<{ phoneNumber: string }, boolean>(
    '/techSupport/sendSmsCode',
    { phoneNumber }
  );
  if (typeof resultOrErrorCode === 'string') {
    return false;
  }
  return !!resultOrErrorCode;
};

export const TechSupportApi = {
  getRedisConfigs,
  setPraiseWallMinPrice,
  getSmsCodeStatus,
  sendSmsCode,
};
